import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ActionsContainer from "../../../Pages/EditProduct/Components/ActionsContainer";
import Button from "@material-ui/core/Button";
import ToolbarContainer from "../../../Pages/EditProduct/Components/ToolbarContainer";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "../../../Components/AppBar";
import SubHeader from "../../../Components/SubHeader";
import TemplatePage from "./TemplatePage";
import {Trans} from "react-i18next";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    toolbar: {
        backgroundColor: 'white',
        flexGrow: 0,
        flexShrink: 0
    },
    button: {
        backgroundColor: 'black',
        color: 'white',
        width: '64px',
        height: '64px',
        justifyContent: 'center',
        display: 'center',
        borderRadius: '32px',
        '&:hover': {
            color: 'white',
            backgroundColor: 'black'
        },
        '&.Mui-disabled': {
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    },

    buttonWithText: {
        fontSize: '16px'
    },

    toolBarContainer: {
        width: '100%',
        overflowX: 'auto',
    },

    toolbarItems: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexWrap: 'nowrap',
        '& > li': {
            flex: '0 0 auto',
            textAlign: 'center',
            marginLeft: theme.spacing(2)
        },
        '& h6': {
            whiteSpace: 'nowrap'
        }
    },

    rightMenuSpacer: {
        width: theme.spacing(1)
    },
}))

export default ({templateInstance, nextPage, previousPage, page, userImages, changeMenu}) => {
    const classes = useStyles();
    return <div className={classes.mainContainer}>
        <AppBar disableGutters/>
        <SubHeader>Change image</SubHeader>

        <TemplatePage page={page} templateInstance={templateInstance}
                      nextPage={nextPage} previousPage={previousPage}
        />

        <ToolbarContainer>
            <div className={classes.toolBarContainer}>
                <ul className={classes.toolbarItems}>
                    <li>
                        <IconButton>

                        </IconButton>
                    </li>
                    {userImages.map(userImage => {
                        return <li>Image</li>
                    })}
                </ul>
            </div>
            <ActionsContainer>
                <Button color="primary"><Trans>Cancel</Trans></Button>
                <Button color="primary" onClick={() => changeMenu('main')}><Trans>Done</Trans></Button>
            </ActionsContainer>
        </ToolbarContainer>
    </div>
}